module.exports = __webpack_public_path__ + "static/media/fingerprint.9e689122.svg";